/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { MetaData, PageLoading, StyledButton } from '@/components/atoms'
import { Footer, NavbarApp } from '@/components/molecules'
import route_list from '@/constant/routeUrl'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import { InputForm, InputSearch } from '@/components'
import * as yup from "yup";
import { useContext, useEffect, useState } from 'react'
import { handleChangeField } from '@/utility/helper/dataMutation'
import { BiChevronDown } from 'react-icons/bi'
import useHelpCenterQuery from '@/utility/hooks/apiHooks/useHelpCenter'
import { getCookie } from '@/utility/helper/cookies'
import DataHandlerContext from '@/utility/context/dataHandler'
import { getSeoMetadata } from '@/utility/apiProcess/seo/server'

export async function getStaticProps() {
  const locale = 'id'
  let seoMetadata = { data: { result: {} } }
  try {
    seoMetadata = await getSeoMetadata({category_slug: 'pages', names: 'help-center'})
  } catch (err) {
    console.error('[getStaticProps] getSeoMetadata failed at build time, falling back to {}', err)
  }

	return {
		props: {
      seoMetadata: seoMetadata.data.result || {},
			...(await serverSideTranslations(locale, ['footer', 'navbar', 'helpcenter'])),
		},
	}
}

const HelpCenter = (props) => {
  const {language, token, role, dataUser, dispatch}:any = useContext(DataHandlerContext)
	const { t } = useTranslation('helpcenter')
	const router = useRouter()
  const [timer, setTimer] = useState<NodeJS.Timeout | number>(0)
  const [formToState, setFormToState] = useState([
		{
      title: "",
      placeholder: 'Search faq',
      type: 'text',
      value: '',
      name: 'search',
      error: '',
    },
  ])
	const { loadingFaqTopics, faqTopics, handleChangeTopic, startFaqTopics, faqByTopic, startFaqByTopic} = useHelpCenterQuery()

  const handleOnChange = (event:any, targetMutation:any, setTargetMutation:any) => {
    let clone_filter = _.cloneDeep(formToState)
    const targetType = event.target.type
    if(targetType === 'search') {
      clone_filter = handleChangeField(event, targetMutation)
    } else if(targetType === 'select') {
      clone_filter = handleChangeSelect(event, targetMutation)
    }
    setTargetMutation(clone_filter)
    
    clearTimeout(timer)
    const new_time = setTimeout(() => {
      handleFilter(clone_filter, 'filter_data')
    }, 2000)
    
    setTimer(new_time)
  }

	const handleFilter = (params:any = null, type:string) => {
    let filter_data:any = {}
    // let clone_row_pagination = _.cloneDeep(rowsPagination)
    
    if(type === 'filter_data') {
      params.forEach((item:any) => {
        if(item.value) {
          if(_.isObject(item.value) && !_.isDate(item.value)) {
            filter_data[item.name] = item.value.value
          } else if(_.isDate(item.value)) {
            filter_data[item.name] = dayjs(item.value).format('YYYY-MM-DD')
          } else {
            filter_data[item.name] = item.value
          }
        }
      })

      filter_data = _.merge(filter_data)
    } else if(type === 'pagination') {
      _.cloneDeep(filterSearch).forEach((item:any) => {
        if(item.value) {
          filter_data[item.name] = item.value
        }
      })
      filter_data = _.merge(filter_data, params)
    } else {
      let clone_filter = _.cloneDeep(filterSearch)
      clone_filter = clone_filter.map((item:any) => {
        return {
          ...item,
          value: ''
        }
      })
      setFilterSearch(clone_filter)
    }

		const selected_id = faqTopics.filter((item:any) => item.isActive)[0].id
		filter_data.id = selected_id
    startFaqByTopic(filter_data)
  }

	useEffect(() => {
    if(!_.isEmpty(language)) {
			startFaqTopics({lang: language})
    }
  }, [language])
 
	if(loadingFaqTopics) {
		return <PageLoading />
	}
          
	return (
		<div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
      <MetaData title={props.seoMetadata.title} ogImage="https://i.ibb.co/bzC5z1g/socialbreadlogo.jpg" ogTitle={props.seoMetadata.title} keywords={props.seoMetadata.keywords} ogDescription={props.seoMetadata.description} />
			<div className='tw-newsroom-banner' id='newsroom-banner'>
				<div className='tw-m-auto md:tw-px-0 tw-py-8 tw-px-4 tw-max-w-6xl tw-mx-auto'>
					<h2 className='tw-text-white md:tw-text-4xl tw-text-2xl tw-font-semibold tw-text-center'>
						{t('helpcenter.title')}
					</h2>
				</div>
			</div>
			<div className='tw-w-full tw-min-h-[500px] tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-[#F1F1F1] md:tw-rounded-[40px] tw-rounded-[20px]'>
				<div className='tw-newsroom-container'>
					<div className='tw-max-w-6xl tw-mx-auto tw-my-8 md:tw-px-0 tw-px-4 tw-text-justify'>
						<h1 className='tw-text-dark-green tw-text-xl tw-font-semibold tw-text-center tw-mb-5'>{t('helpcenter.description')}</h1>
            <div className='tw-max-w-2xl tw-m-auto tw-mb-28'>
              <InputSearch value={formToState[0].value} name={formToState[0].name} placeholder={formToState[0].placeholder} onChange={e => handleOnChange(e, formToState, setFormToState)}/>
            </div>
						<div className='tw-max-w-3xl tw-m-auto tw-flex tw-flex-col tw-justify-center tw-mb-10'>
              <h1 className='tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-text-4xl tw-font-semibold tw-text-center tw-mb-3'>{t('helpcenter.faq_title')}</h1>
              <span className='tw-text-center'>{t('helpcenter.faq_desc')}</span>
            </div>
            <div className='tw-max-w-3xl tw-mx-auto tw-mb-16 tw-grid tw-grid-cols-3 md:tw-gap-7 tw-gap-1'>
							{faqTopics.map((data, index) => {
								return (
									<button className='tw-flex tw-flex-col tw-items-center' key={`faq_${index}`} onClick={() => handleChangeTopic(data.id)}>
										<div className={`tw-w-full tw-shadow-md tw-bg-white md:tw-px-10 tw-px-5 md:tw-py-14 tw-py-7 tw-flex tw-items-center tw-justify-center ${data.isActive && 'tw-border-dark-green tw-border-2'}`}>
											<div style={{background: data.img}} className='tw-bg-light-green tw-flex tw-items-center tw-justify-center md:tw-p-6 tw-p-3 tw-rounded-full'>
												<img src={data.img} alt="" className='md:tw-h-[73px] md:tw-w-[70px] tw-h-[33px] tw-w-[30px]' />
											</div>
										</div>
										<span className='tw-text-dark-green md:tw-text-xl sm:tw-text-md tw-text-xs tw-text-center tw-font-semibold tw-mt-3'>{data.label}</span>
									</button>
								)
							})}
            </div>
						
						<div className='tw-w-full tw-shadow-md tw-bg-white tw-py-10 tw-px-10 tw-flex tw-flex-col tw-gap-10'>
							{faqByTopic.map((data, index) => {
								return (
									<button onClick={() => router.push(route_list.help_center_detail(data.id))} className='tw-flex tw-justify-between tw-items-center tw-pb-3 tw-border-b tw-border-gray-700 tw-w-full' key={`faq_by_topic_${index}`}>
										<h2 className='tw-text-transparent tw-text-left tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-text-lg tw-font-semibold'>
											{data.label}
										</h2>
										<div>
											<BiChevronDown
												className={`tw-rotate-[-90deg] tw-text-dark-green tw-text-4xl`}
											/>
										</div>
									</button>
								)
							})}
							{faqByTopic.length === 0 && (
								<div className='tw-flex tw-justify-center tw-items-center tw-pb-3 tw-border-b tw-border-gray-700 tw-w-full'>
									<h2 className='tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-text-lg tw-font-semibold'>
										No Data
										</h2>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default HelpCenter

